"use client"

import { v7 as uuidv7 } from "uuid"
import { mirrorToLuigi } from "./scripts/luigisCollector"

export const dispatchGtag = (name: string, data: object) => {
  try {
    if (typeof window === "undefined") return
    window.gtag?.("event", name, data)
  } catch {
    // silent fail — tracking must never break the app
  }
}

export const dispatchExponea = (name: string, data: object) => {
  try {
    if (typeof window === "undefined") return
    window.exponea?.track(name, data)
  } catch {
    // silent fail — tracking must never break the app
  }
}

export const dispatchDataLayerPush = (
  payload: Record<string, unknown>,
  onDispatched?: () => void
): boolean => {
  try {
    if (typeof window === "undefined") return false
    window.dataLayer = window.dataLayer || []

    let finalPayload: Record<string, unknown> = payload
    // Normalize: replace legacy `ecommerce` key with standardized
    // eventModel + namespaced key. Generates event_id for deduplication.
    // Handles protected CartState code that still passes ecommerce.
    if ("ecommerce" in payload && "event" in payload) {
      const { ecommerce, ...rest } = payload
      const eventName = rest.event as string
      const normalized = {
        ...(ecommerce as Record<string, unknown>),
        event_id: uuidv7(),
      }
      finalPayload = {
        ...rest,
        eventModel: normalized,
        [`${eventName}_eventModel`]: normalized,
      }
    }

    window.dataLayer.push(finalPayload)
    mirrorToLuigi(payload) // lbx_* side-emit using pre-normalization payload. See DEV-9479.
    onDispatched?.()
    return true
  } catch {
    // silent fail — tracking must never break the app
    return false
  }
}

export const dispatchEventModelBridge = (name: string, data: object) => {
  try {
    if (typeof window === "undefined") return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      eventModel: data,
      [`${name}_eventModel`]: data,
    })
  } catch {
    // silent fail — tracking must never break the app
  }
}

export const dispatchGtagSet = (key: string, data: object) => {
  try {
    if (typeof window === "undefined") return
    window.gtag?.("set", key, data)
  } catch {
    // silent fail — tracking must never break the app
  }
}
